import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class BankRulesQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(company_id:String|Number): Promise<any> {
    let args = { 
        company_id: company_id,
    }
    this.frontend.debit_bank_rules = [];
    this.frontend.credit_bank_rules = [];
    let res = await this.dispatcher.dispatch('company.bank_rules', args);    
    if (!res.hasOwnProperty('error')){
      if ((res.hasOwnProperty('debit')) && (res.debit.hasOwnProperty('rules')))  {    
        for (var i = 0; i < res.debit['rules'].length; i++) {
          res.debit['rules'][i]['order']=i
          res.debit['rules'][i]['visible']=true;
          if (res.debit['rules'][i]['concept'] != '' && res.debit['rules'][i]['concept'] != null) {
            res.debit['rules'][i]['show_concept'] = true;
          }
          else {
            res.debit['rules'][i]['show_concept'] = false;
          }
          this.frontend.debit_bank_rules.push(res.debit['rules'][i]);
        }  
       
      }
      else {
        this.frontend.debit_bank_rules = [];
      }
      if ((res.hasOwnProperty('credit')) && (res.credit.hasOwnProperty('rules')))  {
        for (var i = 0; i < res.credit['rules'].length; i++) {
          res.credit['rules'][i]['order']=i;
          res.credit['rules'][i]['visible']=true;
          if (res.credit['rules'][i]['concept'] != '' && res.credit['rules'][i]['concept'] != null) {
            res.credit['rules'][i]['show_concept'] = true;
          }
          else {
            res.credit['rules'][i]['show_concept'] = false;
          }
          this.frontend.credit_bank_rules.push(res.credit['rules'][i]);
        }  
           
      } else {
        this.frontend.credit_bank_rules = [];
      }
    }
    else {
      this.frontend.debit_bank_rules = [];
      this.frontend.credit_bank_rules = [];
      return res;
    }
  }
}